// @flow
import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

type RenderOptions = { store: {}, theme: {} };

export function createApp(
  Component: React.ComponentType<any>,
  { store, theme }: RenderOptions,
): React.Element<any> {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Component />
      </ThemeProvider>
    </Provider>
  );
}

export function renderApp(
  Component: React.ComponentType<any>,
  node: Element,
  options: RenderOptions,
): void {
  render(createApp(Component, options), node);
}

export default renderApp;



// WEBPACK FOOTER //
// ./src/renderApp.jsx